import React from "react";
import type { PriceTier } from "../types/megapack";
import { CTAButton } from "./CTAButton";
import { DiscountBadge } from "./DiscountBadge";
import { E } from "./Emoji";
type PriceCardProps = {
  tier: PriceTier;
};

/** Tarjeta centrada para el cierre de la página */
export function PriceCard({
  tier
}: PriceCardProps) {
  const isPro = tier.id === "pro";
  return <article className={`rounded-2xl border bg-navy p-6 text-center ${isPro ? "border-2 border-bright shadow-[0_0_30px_rgba(77,148,255,0.3)]" : "border-line/50"}`} data-id="element-33" data-mp="2wh233ixnl51g">
      <span className="text-3xl" data-id="element-34" data-mp="31dsi02xq1ula"><E data-id="element-35" data-mp="2mjdvhsey831v">{tier.emoji}</E></span>
      <h3 className="mt-2 text-xl font-black uppercase text-white" data-id="element-36" data-mp="2mi2t9x15j3cv">
        <E data-id="element-37" data-mp="2rhfob526fgqj">{tier.title}</E>
      </h3>
      <p className="mt-1 text-sm text-mute" data-id="element-38" data-mp="2rge3w9z9thw5">{tier.subtitle}</p>
      {tier.referencePrice && <p className="mt-4 text-sm text-mute line-through" data-id="element-39" data-mp="1b2xp0oldgwr5">{tier.referencePrice}</p>}
      <p className={`${tier.referencePrice ? "" : "mt-4"} text-4xl font-black text-sky`} data-id="element-40" data-mp="1g324cbajnlfs">{tier.price}</p>
      <div className="mt-2" data-id="element-41" data-mp="3kn49q0u0b99h">
        <DiscountBadge tier={tier} data-id="element-42" data-mp="3kmcptn9ruzz1" />
      </div>
      <div className="mt-5" data-id="element-43" data-mp="3fnj8tkva0qu4">
        <CTAButton href={tier.href} checkout={{
        value: tier.value,
        contentName: tier.title,
        contentId: tier.id
      }} data-id="element-44" data-mp="3fob56xwp6slg">
          {tier.cta}
        </CTAButton>
      </div>
    </article>;
}